/**
 * istanbul ignore file
 *
 * @format
 */

/** @format */
import { map, retry } from 'rxjs/operators';

import { Chain } from '@shared/data-access/interfaces';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface AemArticleData {
	description: string;
	imageUrl: string;
	title: string;
	url: string;
}

export interface AemArticleDataResponse {
	root: {
		[':items']: {
			container: {
				[':items']: {
					['image_list']: {
						listItems: AemArticleData[];
					};
				};
			};
		};
	};
}

@Injectable({
	providedIn: 'root'
})
export class AemDataService {
	constructor(
		private chain: Chain,
		private http: HttpClient
	) {}

	public getArticles$(article: string, retries = 0): Observable<AemArticleDataResponse> {
		const articleName = article ? article : 'activities';

		const localhostArticleDomains = {
			gg: 'https://beta.golfgalaxy.com',
			pl: 'https://www.publiclands.com',
			dsg: 'https://beta.publiclands.com'
		};

		const url = `${
			window.location.href.includes('localhost')
				? localhostArticleDomains[this.chain.serviceIdentifierAbbr]
				: ''
		}/blog/t/${articleName}.model.json`;

		return this.http.get(url).pipe(
			map((response: AemArticleDataResponse) => {
				if (response && response[':items']) {
					// Return the raw data
					return response[':items'];
				}

				return null;
			}),
			retry(retries)
		);
	}
}
